import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MobxAngularModule } from 'mobx-angular';
import { TooltipModule } from 'ng2-tooltip-directive';
import { TableModule } from '../table/table.module';
import { CdkTableModule } from '@angular/cdk/table';
import { AccountConnectComponent } from './account-connect/account-connect.component';
import { InstagramAuthComponent } from './instagram-auth/instagram-auth.component';
import { AccountStateChangeComponent } from './account-state-change/account-state-change.component';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SharedComponentsModule as PSharedCompMod } from 'netsocial-posting/src/app/components/shared-components/shared-components.module';
import { ResourceManagementComponent } from './resource-management/resource-management.component';
import { AccountListComponent } from './account-list/account-list.component';
import { JoyrideModule } from 'ngx-joyride';

const components = [
  AccountListComponent,
  AccountConnectComponent,
  InstagramAuthComponent,
  AccountStateChangeComponent,
  ResourceManagementComponent,
];

@NgModule({
  declarations: [...components],
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    TooltipModule,
    MobxAngularModule,
    TableModule,
    CdkTableModule,
    SharedComponentsModule,
    PSharedCompMod,
    JoyrideModule.forChild(),
  ],
  exports: [...components],
})
export class AccountModule {}
